import {jsx as _jsx} from "react/jsx-runtime";import {Suspense} from 'react'

import invitationLinkQuery, {} from '~/__generated__/InvitationLinkQuery.graphql'
import useNoIndex from '../hooks/useNoIndex'
import useQueryLoaderNow from '../hooks/useQueryLoaderNow'
import InvitationLink from './InvitationLink'



const InvitationLinkRoot = (props) => {
  useNoIndex()
  const {match} = props
  const {params} = match
  const {token} = params
  const queryRef = useQueryLoaderNow(invitationLinkQuery, {token})
  return _jsx(Suspense, { fallback: '', children: queryRef && _jsx(InvitationLink, { queryRef: queryRef,} )})
}

export default InvitationLinkRoot
